class ArrayUtil {
  static isEmpty(array) {
    return !Array.isArray(array) || array.length === 0;
  }

  static isNotEmpty(array) {
    return !ArrayUtil.isEmpty(array);
  }

  static removeDuplicated(array) {
    const seen = {};
    const out = [];
    const len = array.length;
    let j = 0;
    for (let i = 0; i < len; i += 1) {
      const item = array[i];
      if (seen[item.id] !== true) {
        seen[item.id] = true;
        out[j] = item;
        j += 1;
      }
    }
    return out;
  }

  static sortByProp(array, propName) {
    return array.slice().sort((a, b) => (a[propName] < b[propName] ? -1 : 1));
  }

  static reservedSortByProp(array, propName) {
    return array.slice().sort((a, b) => (a[propName] > b[propName] ? -1 : 1));
  }

  static sortArrayByName(array) {
    return array.slice().sort((a, b) => {
      const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      const nameB = b.name.toUpperCase(); // ignore upper and lowercase

      if (nameA < nameB) {
        return -1;
      }

      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  }

  static sortBenchMarksAlphabet(benchmarks) {
    return benchmarks.slice().sort((a, b) => {
      const nameA = a.displayName.toUpperCase(); // ignore upper and lowercase
      const nameB = b.displayName.toUpperCase(); // ignore upper and lowercase

      if (nameA < nameB) {
        return -1;
      }

      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  }

  static sortBenchMarksPriority(benchmarks) {
    return benchmarks.slice().sort((v1, v2) => v1.priority - v2.priority);
  }

  static sortCSRespondentAlphabet(concurrentStudies) {
    return concurrentStudies.slice().sort((a, b) => {
      const fNameA = a.respondent.firstName.toUpperCase(); // ignore upper and lowercase
      const fNameB = b.respondent.firstName.toUpperCase(); // ignore upper and lowercase

      if (fNameA < fNameB) {
        return -1;
      }

      if (fNameA > fNameB) {
        return 1;
      }

      const lNameA = a.respondent.lastName.toUpperCase(); // ignore upper and lowercase
      const lNameB = b.respondent.lastName.toUpperCase(); // ignore upper and lowercase

      if (lNameA < lNameB) {
        return -1;
      }

      if (lNameA > lNameB) {
        return 1;
      }

      return 0;
    });
  }

  static sortSurveyRespondentAlphabet(surveyRespondents) {
    return surveyRespondents.slice().sort((a, b) => {
      const fNameA = a.respondent.firstName.toUpperCase(); // ignore upper and lowercase
      const fNameB = b.respondent.firstName.toUpperCase(); // ignore upper and lowercase

      if (fNameA < fNameB) {
        return -1;
      }

      if (fNameA > fNameB) {
        return 1;
      }

      const lNameA = a.respondent.lastName.toUpperCase(); // ignore upper and lowercase
      const lNameB = b.respondent.lastName.toUpperCase(); // ignore upper and lowercase

      if (lNameA < lNameB) {
        return -1;
      }

      if (lNameA > lNameB) {
        return 1;
      }

      return 0;
    });
  }

  /**
   * chunk an array
   * @param: arr Array
   * @param: size Int
   */
  static chunk(arr, size) {
    const len = ArrayUtil.isNotEmpty(arr) ? arr.length : 0;
    if (len === 0 || size >= len || size <= 0) return arr;

    let counter = 0;
    const des = [];
    while (counter <= len) {
      const tempArr = arr.slice(counter, counter + size);
      des.push(tempArr);
      counter += size;
    }
    return des;
  }
}

export default ArrayUtil;
